import { render, staticRenderFns } from "./TeamList.vue?vue&type=template&id=0a9ae11a&scoped=true"
import script from "./TeamList.vue?vue&type=script&lang=js"
export * from "./TeamList.vue?vue&type=script&lang=js"
import style0 from "./TeamList.vue?vue&type=style&index=0&id=0a9ae11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9ae11a",
  null
  
)

export default component.exports